
import { IEntity, IEquatable, IOption } from '../types';

/**
 * Collects options from an array of items based on specified keys.
 * @param items The array of items to collect options from.
 * @param keys The keys to collect options for.
 * @returns A promise that resolves to an object containing the collected options.
 */
export async function collectOptions<T extends IEntity = IEntity>(items: T[], ...keys: string[]): Promise<Partial<Record<keyof T, IOption[]>>> {
  const optionsGroup: Partial<Record<keyof T, IOption[]>> = {};
  if (keys.length > 0) {
    items.forEach(item => {
      keys.forEach((key) => {
        const value = item[key as keyof T];
        if (value) {
          let options = optionsGroup[key];
          if (!options) {
            options = [];
            optionsGroup[key as keyof T] = options;
          }
          if (!options.find(x => x.id === value)) {
            options.push({
              id: value as IEquatable,
              name: String(value),
            });
          }
        }
      });
    });
  }
  return optionsGroup;
}
